import React, { Component } from 'react';
import Input from './input';
export default class Textarea extends Component {
  render () {
    return <Input {...this.props} type='textarea' />
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/textarea.js